module.exports = __webpack_public_path__ + "static/Little-Mexico-429-W-Elizabeth-St-Brownsville-TX 78520-da7c5e5953e70f48fa368c9f5357b91a.jpg";